export default class DomService {
  constructor($timeout) {
    'ngInject';
    this.tokenCache = {}; // saves potentially thousands of DOM queries 
    this.$timeout = $timeout;
  }
  
  get modalOpen() {return !!$('.modal').length}
  get isRenderPage() { return !!document.querySelector('.render-template, .render-dynamic'); }

  clearCache() { 
    this.tokenCache = {};
  }
  
  getJqToken(token, isNewToken) {
    const {id} = token;
    if (isNewToken) return $(`#token-new-drop`); // NEW TOKEN DROP
    return $(`#token-${id}`);

    /*
    TODO: check why cache fails sometimes
    if (!this.tokenCache[id]) {
      this.tokenCache[id] = $(`#token-${id}`);
    }
    return this.tokenCache[id];*/
  }
 
  tokenDim(token, attr) {
    return parseFloat(this.getJqToken(token).css(attr)) || 0;
  }

  getJqCssVals($el, attrs) {
    return attrs.reduce( (css, attr) => {
      return {...css, [attr]: parseFloat($el.css(attr)) || 0};
    }, {});
  }
  
  getJqPage(pageId) {
    return $(`#page-preview-window-${pageId}`);
  }
  
  sortByAttr(tokens, attrName) { 
    return [...tokens].sort((a, b) => {
      return this.tokenDim(a, attrName) - this.tokenDim(b, attrName);
    });
  }
  
  getTokenExceededBounds(token, newCss) {
    const $token = this.getJqToken(token);
    const $page = this.getJqPage(token.pageId);
    const $clone = $token.clone().css(newCss);
    $token.parent().append($clone);
    const bounds = this.getExceededBoundaries($clone, $page);
    $clone.remove();
    return Object.values(bounds).some(v => v > 0) ? bounds : null;
  }
  
  getExceededBoundaries($innerEl, $outerEl) {
    const innerRect = $innerEl[0].getBoundingClientRect();
    const outerRect = $outerEl[0].getBoundingClientRect();
    return {
      top: Number((outerRect.top - innerRect.top).toFixed(3)),
      right: Number((innerRect.right - outerRect.right).toFixed(3)),
      bottom: Number((innerRect.bottom - outerRect.bottom).toFixed(3)),
      left: Number((outerRect.left - innerRect.left).toFixed(3)),
    };
  }
  
  isCaptured(innerRect, outerRect) { 
    return !( outerRect.top > innerRect.bottom ||
              outerRect.right < innerRect.left ||
              outerRect.bottom < innerRect.top ||
              outerRect.left > innerRect.right );
  }

  getPageSize(pageId) {
    const $page = $(`#page-preview-window-${pageId}`);
    return this.getJqCssVals($page, ['width', 'height']);
  }
  
  getTokenPageOffset(token) { // offset relative to page
    const $token = this.getJqToken(token);
    const $page = this.getJqPage(token.pageId);
    return this.getRelativeOffset($token, $page);
  }
  
  getRelativeOffset($innerEl, $outerEl) {
    const inner = $innerEl.offset();
    const outer = $outerEl.offset();
    return { left: inner.left - outer.left, top: inner.top - outer.top };
  }

  getTabNumbers(pages, tokens) {
    // position as ordered by (top + left/20)
    const clnPct = attr => parseFloat(attr.replace('%', ''));
    const pgNum = pageId => pages.find(pg => pg.id === pageId).pageNumber;

    return tokens.map(({ layout, id, pageId }) => {
      const $t = $("<p></p>").attr("style", layout);
      const pageFactor = 1000 * parseInt(pgNum(pageId));
      const pos = pageFactor + clnPct($t.css('top')) + clnPct($t.css('left')) / 20;
      return { id, pos };
    })
      .sort((a, b) => a.pos > b.pos ? 1 : -1)
      .reduce((tabN, { id }, i) => ({ ...tabN, [id]: i + 1 }), {});
  }

  isCtrlPressed(event) {
    return (event.ctrlKey || event.metaKey);
  }

  isShiftPressed(event) {
    return event.shiftKey;
  }

  async waitForElement(selector) {
    while ($(selector).length == 0) {
      await new Promise(resolve => this.$timeout(resolve, 100));
    }
  }

  invokeControlsRendered(rootEl = typeof document !== 'undefined' ? document : null) {
    if (!rootEl) return;
    const $root = $(rootEl.nodeType === 9 ? rootEl.documentElement : rootEl);
    if (!$root.length) return;
    $root.find('fe-control').each((_, fe) => {
      const c = fe.firstElementChild;
      if (!c) return;
      const $el = angular.element(c);
      const ctrl =
        $el.isolateScope()?.$ctrl ??
        $el.controller(c.tagName.toLowerCase().replace(/-([a-z])/g, (_, ch) => ch.toUpperCase()));
      if (typeof ctrl?.rendered === 'function') ctrl.rendered();
    });
  }

  getAddReportTokenIds() {
    const addReportTokenIds = new Set();
    $("button.fe-action-report-insert").each(function() {
      const tokenId = $(this).attr("data-token-id");
      tokenId && addReportTokenIds.add(tokenId);
    });
    return addReportTokenIds;
  }

  getReportFieldIds(tokenId) {
    const reportFieldIds = new Set();
    $(`[data-token-id='${tokenId}']`).find('span[data-field-id]').each(function() {
      const tokenId = $(this).attr("data-field-id");
      tokenId && reportFieldIds.add(tokenId);
    });
    return reportFieldIds;
  }

  isMobileWidth(baseWidth = 768) {
    return $(window).width() <= baseWidth;
  }

  scrollToElement(element, delay = 100, scrollOptions = {}) {
    if (!element) return;
    const { behavior = 'auto' } = scrollOptions;
    const doScroll = () => {
      const el = element[0] || element;
      if (el?.scrollIntoView) el.scrollIntoView({ behavior, block: 'center', inline: 'center' });
    };
    if (delay === 0) doScroll();
    else this.$timeout(doScroll, delay);
  }

  warnIfZoomedOnRenderPage(modal) {
    if (!this.isRenderPage) return;
    if (modal._zoomWarned || window.visualViewport?.scale <= 1) return;

    modal._zoomWarned = true;
    alert('This page is zoomed in. Zoom out to see the full dialog.');
  }

  clearModalViewportStyles(dialog) {
    if (!dialog) return;
    dialog.style.removeProperty('margin-top');
    dialog.style.removeProperty('transform');
  }

  bindVisualViewportAlign(modal) {
    if (!this.isRenderPage || !window.visualViewport || modal._vvAlignBound) return;
    modal._vvAlignBound = true;
    modal._vvAlignHandler = () => this.alignModalInVisualViewport(modal);
    window.visualViewport.addEventListener('resize', modal._vvAlignHandler);
    window.visualViewport.addEventListener('scroll', modal._vvAlignHandler);
  }

  unbindVisualViewportAlign(modal) {
    if (!modal?._vvAlignHandler || !window.visualViewport) return;
    window.visualViewport.removeEventListener('resize', modal._vvAlignHandler);
    window.visualViewport.removeEventListener('scroll', modal._vvAlignHandler);
    modal._vvAlignHandler = null;
    modal._vvAlignBound = false;
  }

  alignModalInVisualViewport(modal) {
    const vv = window.visualViewport;
    const dialog = document.querySelector('.modal.in .modal-dialog');
    if (!dialog) return;

    if (modal) modal._viewportDialog = dialog;

    // Top only — !important beats .control-modal { margin-top: 10px !important }.
    dialog.style.setProperty('margin-top', `${Math.max(10, (vv?.offsetTop ?? 0) + 10)}px`, 'important');
    dialog.style.transform = 'translate(0, 0)';
  }

  // Opens a UI Bootstrap modal; adjusts dialog margin-top for pinched visualViewport,
  // delays the zoom alert, and restores scroll to the trigger on close.
  openModal($uibModal, options, { triggerElement, restoreDelay = 100 } = {}) {
    const modal = $uibModal.open(options);

    modal?.rendered?.then(() => {
      this.$timeout(() => {
        this.alignModalInVisualViewport(modal);
        this.bindVisualViewportAlign(modal);
        // Position first; blocking alert on iOS can reset the viewport.
        this.$timeout(() => {
          this.warnIfZoomedOnRenderPage(modal);
          if (modal._zoomWarned) this.alignModalInVisualViewport(modal);
        }, 300);
      }, 100);
    });

    modal.result.finally(() => {
      this.unbindVisualViewportAlign(modal);
      this.clearModalViewportStyles(modal._viewportDialog);
      if (triggerElement) this.scrollToElement(triggerElement, restoreDelay);
    });

    return modal;
  }

  resolveInvalidBlinkTarget(element) {
    const el = element?.[0] || element;
    if (!el?.classList) return el;
    if (!el.classList.contains('fe-report-control') && !el.classList.contains('fe-report')) return el;
    const reportControl = el.querySelector('report-control');
    return reportControl?.querySelector('table') || reportControl?.querySelector('.fe-report-body') ||
      reportControl?.querySelector('.fe-report') || reportControl || el;
  }

  scrollToElementAndFocus(element, { delay = 100, blink = false } = {}) {
    if (!element) return;
    this.$timeout(() => {
      const el = element[0] || element;
      const blinkEl = this.resolveInvalidBlinkTarget(el);
      this.scrollToElement(blinkEl, 0, { behavior: 'smooth' });
      const focusTarget = el?.querySelector?.('report-control')
        || el?.querySelector?.('input:not(.report-required-validator), textarea, select');
      if (focusTarget?.focus) focusTarget.focus();
      if (blink && blinkEl?.classList) {
        blinkEl.classList.add('fe-invalid-blink');
        this.$timeout(() => blinkEl.classList.remove('fe-invalid-blink'), 2500);
      }
    }, delay);
  }

  minAdjustedFontSizePx(doc) {
    const win = doc?.defaultView;
    const MIN_INCHES_FONT_SIZE = 0.12;
    if (!doc?.body || !win) return 96 * MIN_INCHES_FONT_SIZE;
    const span = doc.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    span.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;pointer-events:none;margin:0;padding:0;border:0;line-height:normal;font-size:0.12in;';
    span.appendChild(doc.createTextNode('\u00a0'));
    doc.body.appendChild(span);
    const px = parseFloat(win.getComputedStyle(span).fontSize) || (96 * MIN_INCHES_FONT_SIZE);
    doc.body.removeChild(span);
    return px;
  }

  adjustFontForToken(el, usePercentForFontSize) {
    const doc = el.ownerDocument;
    if (!doc) return;
    const VW_UNITS = 1000;
    const text = el.tagName === 'INPUT'
      ? (el.value != null ? String(el.value) : '')
      : (el.textContent != null ? String(el.textContent).trim() : '');
    if (!text) {
      el.style.removeProperty('font-size');
      el.style.removeProperty('line-height');
      el.style.removeProperty('white-space');
      el.removeAttribute('data-fe-original-font-size');
      return;
    }
    el.style.removeProperty('font-size');
    void el.offsetHeight;
    const style = doc.defaultView.getComputedStyle(el);
    const padL = parseFloat(style.paddingLeft) || 0;
    const padR = parseFloat(style.paddingRight) || 0;
    const TOLERANCE_PX = 4;
    const fieldWidthPx = Math.max(1, (el.clientWidth - padL - padR) - TOLERANCE_PX);
    if (fieldWidthPx <= 0) {
      el.style.removeProperty('font-size');
      el.style.removeProperty('line-height');
      el.style.removeProperty('white-space');
      el.removeAttribute('data-fe-original-font-size');
      return;
    }
    const viewportWidth = doc.defaultView?.innerWidth || 800;
    const container = usePercentForFontSize && el.closest ? el.closest('.render-template-window') : null;
    const referenceWidth = (container && container.clientWidth > 0) ? container.clientWidth : viewportWidth;
    const minFontPx = this.minAdjustedFontSizePx(doc);
    const MIN_VW = Math.min(100, (minFontPx * 100) / referenceWidth);
    const originalPx = parseFloat(style.fontSize) || 16;
    const originalVwUnits = Math.min(Math.floor((originalPx * 100 / referenceWidth) * VW_UNITS), 100 * VW_UNITS);
    const minVwUnits = Math.floor(MIN_VW * VW_UNITS);
    const vwToPx = (vwUnits) => (vwUnits / VW_UNITS) * referenceWidth / 100;
    const textFitsAtVw = (vwUnits) => this.measureTextWidth(text, el, vwToPx(vwUnits)) <= fieldWidthPx;

    const applyInlineFontFromVwUnits = (fitVwUnits) => {
      const fitVw = fitVwUnits / VW_UNITS;
      const isEditableElement = el.tagName === 'INPUT';
      const hasWrappableChar = /[\s-]/.test(text);
      const stillTooWide = !textFitsAtVw(fitVwUnits);
      if (stillTooWide && !isEditableElement && hasWrappableChar) {
        el.style.lineHeight = 'normal';
        el.style.whiteSpace = 'normal';
      } else {
        el.style.removeProperty('line-height');
        el.style.removeProperty('white-space');
      }
      if (usePercentForFontSize) {
        const fitPx = (fitVwUnits / VW_UNITS) * referenceWidth / 100;
        const percentValue = (fitPx / originalPx) * 100;
        el.style.fontSize = `${percentValue.toFixed(4)}%`;
      } else {
        el.style.fontSize = `${fitVw.toFixed(4)}vw`;
      }
    };

    if (textFitsAtVw(originalVwUnits)) {
      if (originalPx + 1e-6 < minFontPx) {
        applyInlineFontFromVwUnits(minVwUnits);
      } else {
        el.style.removeProperty('font-size');
        el.style.removeProperty('line-height');
        el.style.removeProperty('white-space');
        el.removeAttribute('data-fe-original-font-size');
      }
      return;
    }
    if (originalVwUnits < minVwUnits) {
      applyInlineFontFromVwUnits(minVwUnits);
      return;
    }
    let lo = minVwUnits;
    let hi = originalVwUnits;
    while (lo < hi) {
      const mid = Math.ceil((lo + hi) / 2);
      if (textFitsAtVw(mid)) {
        lo = mid;
      } else {
        hi = mid - 1;
      }
    }
    const fitVwUnits = lo;
    applyInlineFontFromVwUnits(fitVwUnits);
  }

  measureTextWidth(text, refEl, fontSizePx) {
    const doc = refEl.ownerDocument;
    const style = doc.defaultView.getComputedStyle(refEl);
    const span = doc.createElement('span');
    span.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;';
    span.style.fontFamily = style.fontFamily;
    span.style.fontSize = `${fontSizePx}px`;
    span.style.fontWeight = style.fontWeight;
    span.style.fontStyle = style.fontStyle;
    span.style.letterSpacing = style.letterSpacing;
    span.textContent = text;
    doc.body.appendChild(span);
    const w = span.offsetWidth;
    doc.body.removeChild(span);
    return w;
  }

  createTextareaClone(sourceEl, widthPx, heightPx, attachToEl) {
    const doc = sourceEl.ownerDocument;
    const clone = sourceEl.cloneNode(false);
    clone.setAttribute('readonly', '');
    clone.setAttribute('disabled', '');
    Object.assign(clone.style, { position: 'absolute', left: '0', top: '0', visibility: 'hidden', pointerEvents: 'none', resize: 'none', overflow: 'hidden' });
    clone.style.width = `${widthPx}px`;
    clone.style.height = `${heightPx}px`;

    const style = doc.defaultView?.getComputedStyle(sourceEl);
    // Copy key inherited styles so measurement matches the real element.
    if (style) {
      clone.style.fontFamily = style.fontFamily;
      clone.style.fontWeight = style.fontWeight;
      clone.style.fontStyle = style.fontStyle;
      clone.style.letterSpacing = style.letterSpacing;
      clone.style.textTransform = style.textTransform;
      clone.style.whiteSpace = style.whiteSpace;
      clone.style.wordBreak = style.wordBreak;
      clone.style.overflowWrap = style.overflowWrap;
    }

    doc.body.appendChild(clone);
    return clone;
  }

  adjustFontForTokenMultiline(el, usePercentForFontSize) {
    const doc = el.ownerDocument;
    if (!doc) return;
    if (el?.dataset?.feAdjustingFont === '1') return;
    if (el?.dataset) el.dataset.feAdjustingFont = '1';

    try {
      const text = el.value != null ? String(el.value) : '';
      if (!text) {
        el.style.removeProperty('font-size');
        el.style.removeProperty('line-height');
        if (el?.dataset) {
          delete el.dataset.feLastTextLen;
          delete el.dataset.feBaseFont;
          delete el.dataset.feBaseLineHeightMult;
        }
        return;
      }

      const container = usePercentForFontSize && el.closest ? el.closest('.render-template-window') : null;
      const referenceWidth = (container && container.clientWidth > 0) ? container.clientWidth : (doc.defaultView && doc.defaultView.innerWidth) || 800;
      const MIN_PX = this.minAdjustedFontSizePx(doc);
      const parentEl = el.parentElement || el;
      const parentFontPx = parseFloat(doc.defaultView.getComputedStyle(parentEl).fontSize) || 16;
      const MIN_VW = (MIN_PX * 100) / referenceWidth;
      const MIN_PCT = (MIN_PX / parentFontPx) * 100;
      const minFontSizeRel = usePercentForFontSize ? MIN_PCT : MIN_VW;
      const curFontSizeStr = (el.style.fontSize || '').trim();
      let curFontSizeRel = 0;
      if (curFontSizeStr.endsWith('%')) curFontSizeRel = parseFloat(curFontSizeStr) || 0;
      else if (curFontSizeStr.toLowerCase().endsWith('vw')) curFontSizeRel = parseFloat(curFontSizeStr) || 0;
      const atMinAlready = curFontSizeRel > 0 && curFontSizeRel <= minFontSizeRel + 0.0001;
      const realOverflows = (el.scrollHeight > el.clientHeight + 1);
      if (atMinAlready && realOverflows) {
        if (el?.dataset) el.dataset.feLastTextLen = String(text.length);
        return;
      }

      const style = doc.defaultView.getComputedStyle(el);
      const padL = parseFloat(style.paddingLeft) || 0;
      const padR = parseFloat(style.paddingRight) || 0;
      const padT = parseFloat(style.paddingTop) || 0;
      const padB = parseFloat(style.paddingBottom) || 0;

      let overflowOrig = el.style.overflow;
      el.style.overflow = 'hidden';
      const viewWidth = el.clientWidth;
      const viewHeight = el.clientHeight;
      el.style.overflow = overflowOrig || '';

      if (viewWidth - padL - padR <= 0 || viewHeight - padT - padB <= 0) {
        el.style.removeProperty('font-size');
        return;
      }

      const textareaClone = this.createTextareaClone(el, viewWidth, viewHeight, el.parentElement);
      try {
        textareaClone.value = text;
        void textareaClone.offsetHeight;
        const hasVerticalScrollbar = (ta) => ta.scrollHeight > ta.clientHeight;
        const unit = usePercentForFontSize ? 'pct' : 'vw';
        let baseFontSizeRel = parseFloat(el.dataset?.feBaseFont || '');
        let baseLineHeightMult = parseFloat(el.dataset?.feBaseLineHeightMult || '');
        if (Number.isNaN(baseFontSizeRel) || baseFontSizeRel <= 0 || Number.isNaN(baseLineHeightMult) || baseLineHeightMult <= 0) {
          const prevInline = el.style.fontSize;
          const prevInlineLineHeight = el.style.lineHeight;
          el.style.removeProperty('font-size');
          el.style.removeProperty('line-height');
          void el.offsetHeight;
          const baseStyle = doc.defaultView.getComputedStyle(el);
          const basePx = parseFloat(baseStyle.fontSize) || 16;
          const baseLineHeightPx = parseFloat(baseStyle.lineHeight) || basePx * 1.2;
          baseLineHeightMult = (baseLineHeightPx > 0 && basePx > 0) ? (baseLineHeightPx / basePx) : 1.2;
          if (unit === 'pct') baseFontSizeRel = (basePx / parentFontPx) * 100;
          else baseFontSizeRel = (basePx * 100) / referenceWidth;
          if (prevInline) el.style.fontSize = prevInline;
          else el.style.removeProperty('font-size');
          if (prevInlineLineHeight) el.style.lineHeight = prevInlineLineHeight;
          else el.style.removeProperty('line-height');
          if (el?.dataset) {
            el.dataset.feBaseFont = String(baseFontSizeRel);
            el.dataset.feBaseLineHeightMult = String(baseLineHeightMult);
          }
        }
        const setTextareaFontSize = (fontSizeRel, target) => {
          const isClone = target === textareaClone;
          if (unit === 'pct') {
            if (isClone) {
              const px = (Number(fontSizeRel) / 100) * parentFontPx;
              target.style.fontSize = `${px.toFixed(4)}px`;
            } else {
              target.style.fontSize = `${Number(fontSizeRel).toFixed(4)}%`;
            }
          } else {
            target.style.fontSize = `${Number(fontSizeRel).toFixed(4)}vw`;
          }
          target.style.lineHeight = String(baseLineHeightMult);
        };

        if (el?.dataset) el.dataset.feLastTextLen = String(text.length);
        const relNoOverflow = Math.max(baseFontSizeRel, minFontSizeRel);
        setTextareaFontSize(relNoOverflow, textareaClone);
        void textareaClone.offsetHeight;
        if (!hasVerticalScrollbar(textareaClone)) {
          setTextareaFontSize(relNoOverflow, el);
          void el.offsetHeight;
          return;
        }

        const EPSILON = 0.0001;
        let loFontSizeRel = minFontSizeRel;
        let hiFontSizeRel = Math.max(baseFontSizeRel, minFontSizeRel);
        while (loFontSizeRel < hiFontSizeRel - EPSILON) {
          const midFontSizeRel = (loFontSizeRel + hiFontSizeRel) / 2;
          setTextareaFontSize(midFontSizeRel, textareaClone);
          void textareaClone.offsetHeight;
          if (!hasVerticalScrollbar(textareaClone)) loFontSizeRel = midFontSizeRel;
          else hiFontSizeRel = midFontSizeRel;
        }
        let fitFontSizeRel = loFontSizeRel;
        const SCROLL_AT_BOTTOM_THRESHOLD_PX = 20;
        const applyFittedFontSizeToTextarea = (fontSizeRel) => {
          const oldScrollTop = el.scrollTop || 0;
          const oldClientHeight = el.clientHeight || 0;
          const oldScrollHeight = el.scrollHeight || 0;
          const distFromBottom = oldScrollHeight - (oldScrollTop + oldClientHeight);
          const caretAtEnd = (typeof el.selectionEnd === 'number') && (typeof el.value === 'string') && (el.selectionEnd === el.value.length);
          const wasAtBottom = distFromBottom <= SCROLL_AT_BOTTOM_THRESHOLD_PX || caretAtEnd;

          // Skip if we're already at this relative size.
          const currentInline = (el.style.fontSize || '').trim();
          const targetStr = unit === 'pct'
            ? `${Number(fontSizeRel).toFixed(4)}%`
            : `${Number(fontSizeRel).toFixed(4)}vw`;
          if (currentInline === targetStr) return;
          setTextareaFontSize(fontSizeRel, el);
          void el.offsetHeight;
          if (fontSizeRel <= minFontSizeRel) return;
          const getMaxTop = () => {
            const curClientHeight = el.clientHeight || 0;
            const curScrollHeight = el.scrollHeight || 0;
            return Math.max(0, curScrollHeight - curClientHeight);
          };
          const curVal = (typeof el.value === 'string') ? el.value : '';
          const curCaretAtEndNow = (typeof el.selectionEnd === 'number') && (el.selectionEnd === curVal.length);
          const maxTopNow = getMaxTop();
          if (wasAtBottom || curCaretAtEndNow) {
            el.scrollTop = maxTopNow;
          } else {
            el.scrollTop = Math.max(0, Math.min(oldScrollTop, maxTopNow));
          }
        };

        applyFittedFontSizeToTextarea(fitFontSizeRel);
        const OVERFLOW_TOL_PX = 1;
        const STEP_REL = unit === 'pct' ? (100 / parentFontPx) : (100 / referenceWidth);
        const MAX_STEPS = 25;
        let safety = 0;
        while (safety < MAX_STEPS && (el.scrollHeight > el.clientHeight + OVERFLOW_TOL_PX) && fitFontSizeRel > minFontSizeRel + EPSILON) {
          fitFontSizeRel = Math.max(minFontSizeRel, fitFontSizeRel - STEP_REL);
          applyFittedFontSizeToTextarea(fitFontSizeRel);
          safety += 1;
        }
      } finally {
        if (textareaClone.parentNode) textareaClone.parentNode.removeChild(textareaClone);
      }
    } finally {
      if (el?.dataset) delete el.dataset.feAdjustingFont;
    }
  }

  getFeControlInnerWidth(feCtrl, win) {
    const style = win.getComputedStyle(feCtrl);
    const padL = parseFloat(style.paddingLeft) || 0;
    const padR = parseFloat(style.paddingRight) || 0;
    const tolerance = 4;
    return Math.max(0, feCtrl.clientWidth - padL - padR - tolerance);
  }
}